module.exports = __webpack_public_path__ + "static/img/pic21.ebb3f03.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic21.png
// module id = rHjk
// module chunks = 0